import React from "react";
import Admissao from "../../pages/colaboradores/Admissao";
import Ativo from "../../pages/colaboradores/Ativo";
import Colaboradores from "../../pages/colaboradores/Colaboradores";
import JornadaTrabalho from "../../pages/colaboradores/JornadaTrabalho";

const prefix = process.env.REACT_APP_PREFIX;

const colaboradoresRoutes = [
  {
    path: `${prefix}/colaboradores/JornadaTrabalho`,
    component: <JornadaTrabalho />,
    title: "jornada de trabalho",
  },
  {
    path: `${prefix}/colaboradores/Colaborador/ativo/:uid`,
    component: <Ativo />,
    title: "Dados do colaborador",
  },
  {
    path: `${prefix}/colaboradores/Colaborador/admissao/:uid`,
    component: <Admissao />,
    title: "Solicitar admissão",
  },
  {
    path: `${prefix}/colaboradores/Colaboradores`,
    component: <Colaboradores />,
    title: "Colaboradores",
  },
];

export default colaboradoresRoutes;
